export const LABELS_LIMIT = 5;
export const DEFAULT_MENU_SIZE = 20;
export const TRUNCATE_FROM_THRESHOLD = 50;

export enum ViewportType {
  DESKTOP = 'DESKTOP',
  MOBILE = 'MOBILE',
}

export const DIVIDER_TYPE = {
  SOLID: 0,
  DASHED: 1,
  DOTTED: 2,
} as const;

export const ITEM_LAYOUT_TYPE = {
  STRIP: 0,
  CARD: 1,
} as const;

export const ITEM_IMAGE_PLACEMENT = {
  RIGHT: 0,
  LEFT: 1,
} as const;

export const ITEM_IMAGE_RATIO = {
  /**
   *  image ratio 1/1
   * */
  SQUARE: 0,

  /**
   *  image ratio 4/3
   * */
  STANDARD: 1,

  /**
   *  image ratio 16/9
   * */
  WIDE: 2,
} as const;

export const ITEM_IMAGE_RESIZE = {
  CROP: 0, // object-fit: cover
  FIT: 1, // object-fit: contain
} as const;

export const ICON_POSITION = {
  LEFT: 0,
  RIGHT: 1,
  TOP: 2,
  BOTTOM: 3,
} as const;

export const HEADER_PLACEMENT = {
  BELOW: 0,
  ON: 1,
} as const;

export enum ADD_TO_CART_BUTTON_PLACEMENT {
  ITEM_INFO = 0,
  ON_IMAGE = 1,
}

export enum QUICK_ADD_BUTTON_STYLE {
  FILLED = 0,
  OUTLINED = 1,
  PILL_FILLED = 2,
  PILL_OUTLINED = 3,
}

export enum QUICK_ADD_BUTTON_CONTENT {
  ICON = 0,
  TEXT = 1,
  ICON_AND_TEXT = 2,
}

export enum QUICK_ADD_BUTTON_WIDTH {
  STRETCHED = 0,
  FIX_TO_TEXT = 1,
}

export enum QUICK_ADD_ICON_TYPE {
  CART = 0,
  ECOM_CART = 1,
  STORES = 2,
  SHOPPING_BAG = 3,
  PLUS = 4,
}

export enum QUICK_ADD_HORIZONTAL_ALIGNMENT {
  LEFT = 0,
  CENTER = 1,
  RIGHT = 2,
}
